import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ExceptionManager } from "Core/logManager";
import { clientQuery, clientMutation } from "Core/data/GraphQLApi";
import { endpoints } from "Core/defaultValues";

const INIT_STATE = {
  tags: [],
  tagsTotal: 0,
  loadingTags: false,
  errorTags: false,
  tagsFilters: {
    openSearch: "",
    limit: 0,
    offset: 0,
  },
  driversTagDeleteResponse: null,
  loadingDriversTagDelete: false,
};

const route = "modules/driver/views/tags/redux/slice";

export const searchDriversTags = createAsyncThunk(
  `${route}/searchDriversTags`,
  async (payload, { rejectWithValue, dispatch }) => {
    const { openSearch, limit, offset } = payload;
    try {
      let data = await clientQuery(
        `
            query searchTagsInline ($openSearch: String, $entityName: String!, $limit: Int, $offset: Int) {
            searchTagsInline (openSearch: $openSearch, entityName: $entityName, limit: $limit, offset: $offset) {
               items {
                    id
                    label
                    color
                    disabled
                    driversCount
               }
               total
            }
        }
        `,
        {
          openSearch,
          entityName: "Driver",
          limit,
          offset,
        },
        endpoints.GRAPHQL_GENERAL
      );
      if (data) {
        const {
          searchTagsInline: { items, total },
        } = data;
        return { items, total };
      } else {
        throw "Error while getting driver tags";
      }
    } catch (exc) {
      // ALWAYS RETURN ACTION
      ExceptionManager(exc, route, "searchDriversTags");
      rejectWithValue(exc);
    }
  }
);

export const deleteDriversTag = createAsyncThunk(
  `${route}/deleteDriversTag`,
  async (payload, { rejectWithValue, dispatch }) => {

    try {
      const { items } = payload;
      let mutations = [];

      items.forEach((item, index) => {
        mutations.push(
          `tag${index}: updateTagAssignment(
                    tagId: ${item?.tagId}
                    entityName: Driver
                    entityIds: [${item?.entityIds?.join(", ")}]
                    action: Delete
                )
            `
        );
      });

      const mutation = `mutation{${mutations.join("")}}`;

      const response = await clientMutation(
        mutation,
        {},
        endpoints.GRAPHQL_GENERAL
      );
      if (mutation && response.tag0) {
        return { response: response.tag0 };
      } else {
        throw "Error while delete driver tags";
      }
    } catch (exc) {
      // ALWAYS RETURN ACTION
      ExceptionManager(exc, route, "deleteDriversTag");
      rejectWithValue(exc);
    }
  }
);

export const driverTagsSliceRedux = createSlice({
  name: "driver/driverTagsSliceRedux",
  initialState: INIT_STATE,
  reducers: {
    resetDriverTagsState: (state, action) => {
      return action.payload
        ? { ...state, ...action.payload }
        : { ...INIT_STATE };
    },
  },
  extraReducers: (builder) => {
    //searchDriversTags
    builder.addCase(searchDriversTags.pending, (state, action) => {
      state.loadingTags = true;
    });
    builder.addCase(searchDriversTags.fulfilled, (state, { payload }) => {
      state.tags = payload?.items;
      state.tagsTotal = payload?.total;
      state.errorTags = payload?.error;
      state.loadingTags = false;
    });
    builder.addCase(searchDriversTags.rejected, (state, action) => {
      state.tags = [];
      state.errorTags = action.payload.error;
    });

    //deleteDriversTag
    builder.addCase(deleteDriversTag.pending, (state, action) => {
      state.loadingDriversTagDelete = true;
    });
    builder.addCase(deleteDriversTag.fulfilled, (state, { payload }) => {
      state.driversTagDeleteResponse = payload?.response;
    });
    builder.addCase(deleteDriversTag.rejected, (state, action) => {
      state.driversTagDeleteResponse = null;
      state.loadingDriversTagDelete = false;
    });
  },
});

const { actions, reducer } = driverTagsSliceRedux;

export const { resetDriverTagsState } = actions;

export default reducer;
